import { render, staticRenderFns } from "./neibuPup.vue?vue&type=template&id=1a78dfd4&"
import script from "./neibuPup.vue?vue&type=script&lang=js&"
export * from "./neibuPup.vue?vue&type=script&lang=js&"
import style0 from "./neibuPup.vue?vue&type=style&index=0&scope=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports